<template>
  <div class="px-3">

    <RegistrarEnvioImagenes
      :saveInState="saveImagenesInState"
      :esIess="esCoberturaIess"
      :maxEnvios="maxEnvios"
      :tokenAtencion="tokenAtencion"
      alertNoRegistros
    />
    
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { RegistrarEnvioImagenes } from '@/views/imagen/components';
import { citasService } from '../../services';

export default {
  name: "FormAddImagen",

  components: {
    RegistrarEnvioImagenes
  },


  created() {
    this.getTokenAtencion();
  },


  data() {
    return {

      tokenAtencion: null
    }
  },


  methods: {


    async getTokenAtencion(){

      this.tokenCita = this.$route.params.token;
      if(!this.tokenCita) return;

      const responseAtencion = await citasService.getAtencion(this.tokenCita);

      if(!responseAtencion || !responseAtencion.length){
        console.error('No se encontraro una atencion');
        return;
      }

      this.tokenAtencion = responseAtencion[0].token;
    },
    
    saveImagenesInState(imagenesList) {
      this.$store.commit("setDataEnvioImagenes", imagenesList);
    }
  },


  computed: {
    ...mapState({
      stDataCobertura: state => state.citas?.ingresoCitas?.dataInfoCita?.cobertura,
    }),

    esCoberturaIess() {
      return this.stDataCobertura === '1';
    },

    maxEnvios() {
      return this.stDataCobertura === '5' ? null : 1;
    }
  }

}
</script>